import React, { FC } from 'react';
import { AddPaymentProps } from './types';
import { RegistrationAddPayment } from './RegistrationAddPayment';
import { CheckoutAddPayment } from './CheckoutAddPayment';

export const AddPayment: FC<AddPaymentProps & { isRegistration?: boolean; disableTrial?: boolean }> = React.memo(
  ({
    addPaymentError,
    addPaymentLoading,
    onAddPaymentOption,
    onUpdatePaymentOption,
    threeDActionContext,
    onThreeDActionError,
    currencyCode,
    countryCode,
    paywallLocation,
    allowCancel,
    onCompletePurchase,
    selectedPlan,
    currentPurchase,
    completedPurchase,
    completePurchaseLoading,
    completePurchaseError,
    selectedPaymentOption,
    wallet,
    onSelectPaymentOption,
    onNext,
    onCancel,
    setIsAnnual,
    isAnnual,
    plans,
    setSelectedPlan,
    onPaymentCompleteRedirect,
    isRegistration = false,
    disableTrial = false,
    onApplyCoupon,
    couponLoading,
    applyCouponError,
    onRemoveCoupon,
    currentProfile,
    showApplePayButton,
    onClickApplePay,
    requestRecurlyTokenAndValidate,
    handlePaymentPriorityChange,
    paymentMethodFormRef,
    paymentMethodFormikRef,
    setShowAddPaymentMethod,
    showAddPaymentMethod,
    discountType,
    purchaseableItems,
    closeBillingPopup,
    modalVariant,
    isModal,
    enableAnnualRenewal,
  }) =>
    isRegistration ? (
      <RegistrationAddPayment
        addPaymentError={addPaymentError}
        addPaymentLoading={addPaymentLoading}
        onAddPaymentOption={onAddPaymentOption}
        onUpdatePaymentOption={onUpdatePaymentOption}
        threeDActionContext={threeDActionContext}
        onThreeDActionError={onThreeDActionError}
        currencyCode={currencyCode}
        countryCode={countryCode}
        paywallLocation={paywallLocation}
        allowCancel={allowCancel}
        onCompletePurchase={onCompletePurchase}
        selectedPlan={selectedPlan}
        currentPurchase={currentPurchase}
        completedPurchase={completedPurchase}
        completePurchaseLoading={completePurchaseLoading}
        completePurchaseError={completePurchaseError}
        selectedPaymentOption={selectedPaymentOption}
        wallet={wallet}
        onSelectPaymentOption={onSelectPaymentOption}
        onNext={onNext}
        onCancel={onCancel}
        setIsAnnual={setIsAnnual}
        isAnnual={isAnnual}
        plans={plans}
        setSelectedPlan={setSelectedPlan}
        onPaymentCompleteRedirect={onPaymentCompleteRedirect}
        disableTrial={disableTrial}
        onApplyCoupon={onApplyCoupon}
        couponLoading={couponLoading}
        applyCouponError={applyCouponError}
        onRemoveCoupon={onRemoveCoupon}
        currentProfile={currentProfile}
        showApplePayButton={showApplePayButton}
        onClickApplePay={onClickApplePay}
        requestRecurlyTokenAndValidate={requestRecurlyTokenAndValidate}
        handlePaymentPriorityChange={handlePaymentPriorityChange}
        paymentMethodFormRef={paymentMethodFormRef}
        paymentMethodFormikRef={paymentMethodFormikRef}
        setShowAddPaymentMethod={setShowAddPaymentMethod}
        showAddPaymentMethod={showAddPaymentMethod}
        discountType={discountType}
      />
    ) : (
      <CheckoutAddPayment
        addPaymentError={addPaymentError}
        addPaymentLoading={addPaymentLoading}
        onAddPaymentOption={onAddPaymentOption}
        onUpdatePaymentOption={onUpdatePaymentOption}
        threeDActionContext={threeDActionContext}
        onThreeDActionError={onThreeDActionError}
        currencyCode={currencyCode}
        countryCode={countryCode}
        paywallLocation={paywallLocation}
        allowCancel={allowCancel}
        onCompletePurchase={onCompletePurchase}
        selectedPlan={selectedPlan}
        currentPurchase={currentPurchase}
        completedPurchase={completedPurchase}
        completePurchaseLoading={completePurchaseLoading}
        completePurchaseError={completePurchaseError}
        selectedPaymentOption={selectedPaymentOption}
        wallet={wallet}
        onSelectPaymentOption={onSelectPaymentOption}
        onNext={onNext}
        onCancel={onCancel}
        onApplyCoupon={onApplyCoupon}
        couponLoading={couponLoading}
        applyCouponError={applyCouponError}
        onRemoveCoupon={onRemoveCoupon}
        showApplePayButton={showApplePayButton}
        onClickApplePay={onClickApplePay}
        requestRecurlyTokenAndValidate={requestRecurlyTokenAndValidate}
        handlePaymentPriorityChange={handlePaymentPriorityChange}
        paymentMethodFormRef={paymentMethodFormRef}
        paymentMethodFormikRef={paymentMethodFormikRef}
        setShowAddPaymentMethod={setShowAddPaymentMethod}
        showAddPaymentMethod={showAddPaymentMethod}
        purchaseableItems={purchaseableItems}
        closeBillingPopup={closeBillingPopup}
        modalVariant={modalVariant}
        isModal={isModal}
        enableAnnualRenewal={enableAnnualRenewal}
      />
    )
);
